export const TOP_LINKS = {
  emailUs: 'mailto:officerinstitute@iatse.net',
  iatseWebsite: 'https://iatse.net',
  trainingTrustFund: 'https://reports.iatsetrainingtrust.org',
}
